import React, { useContext, useState, useEffect } from 'react';

export const CatalogContext = React.createContext();

export default function CatalogContextProvider({ children }) {
  const [carrierId, setCarrierId] = useState(undefined);
  const [scacUpdated, setScacUpdated] = useState(false);
  const [carrierSelected, setCarrierSelected] = useState({});

  const [defOptions, setDefOptions] = useState({
    text: "",
    value: null,
    payload: {},
    scacUpdated : false
  });

  // Reset carrierId and carrierSelected on component mount
  useEffect(() => {
    setCarrierId(undefined);
    setCarrierSelected({});
  }, []);

  const state = {
    carrierId,
    setCarrierId,
    defOptions,
    setDefOptions,
    carrierSelected,
    setCarrierSelected,
    scacUpdated,
    setScacUpdated
  };

  return (
    <CatalogContext.Provider value={{ ...state }}>{children}</CatalogContext.Provider>
  );
}

export const useCatalogContext = () => {
  const context = useContext(CatalogContext);
  if (!context) {
    throw new Error(
      'useCatalogContext cannot be rendered outside the CatalogContext.Provider component'
    );
  }
  return {
    carrierId: context.carrierId,
    setCarrierId: context.setCarrierId,
    defOptions: context.defOptions,
    setDefOptions: context.setDefOptions,
    setCarrierSelected: context.setCarrierSelected,
    carrierSelected: context.carrierSelected,
    scacUpdated: context.scacUpdated,
    setScacUpdated: context.setScacUpdated
  };
};